// 云存储录像列表
//   POST /api/cloud-history
//   body: { device_id, channel_id, start_time, end_time }  (unix epoch s 字符串)
//   返回: { code, data: { start_utc, end_utc, uploadinfo? }[] }
import axios from 'axios';
import { useAuthStore } from '../stores/auth.js';

export interface CloudSegment {
	start_utc: number;
	end_utc: number;
	uploadinfo?: string;
}

export interface CloudHistoryResponse {
	code: number | string;
	msg?: string;
	data?: CloudSegment[];
}

export async function fetchCloudHistory(opts: {
	device_id: string;
	channel_id: string | number;
	start_time: number;        // unix epoch seconds
	end_time: number;
}): Promise<CloudHistoryResponse> {
	const token = useAuthStore.getState().token;
	const { data } = await axios.post<CloudHistoryResponse>('/api/cloud-history', {
		device_id: opts.device_id,
		channel_id: String(opts.channel_id),
		start_time: String(opts.start_time),
		end_time: String(opts.end_time),
	}, {
		headers: token ? { Authorization: `Bearer ${token}` } : {},
		timeout: 10000,
	});
	return data;
}

/** 拿云回放 m3u8 URL（hls.js 直接可播） */
export async function fetchPlaybackUrl(opts: {
	device_id: string;
	channel_id: string | number;
	start_time: number;
	end_time: number;
}): Promise<string> {
	const { data } = await axios.post<{ ok: boolean; url: string }>('/api/cloud-playback-url', {
		device_id: opts.device_id,
		channel_id: String(opts.channel_id),
		start_time: String(opts.start_time),
		end_time: String(opts.end_time),
	}, { timeout: 5000 });
	return data.url;
}
